import { Headerbar } from "components/Headerbar/Headerbar";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { TableTree } from "components/TableTree/TableTree";
import { useEffect, useState } from "react";
import { ENDPOINTS } from "utils/endpoints";
import { getReferencesActions } from "./api/api";
import { ModalForm } from "components/ModalForm/ModalForm";
import { ActionsOfReference } from "./ActionsOfReference";
import { JobActionList } from "pages/OfficeAutomation/Cartable/components/ActionList/components/JobActionList/JobActionList";
import { JobActions } from "pages/OfficeAutomation/Cartable/components/ActionList/components/JobActions/JobActions";
import { DynamicForm } from "types/types";
import { ModalStepper } from "components/ModalStepper/ModalStepper";
import { getDynamicForm } from "pages/OfficeAutomation/Cartable/components/ActionList/api/api";
interface ReferenceHistoryPropsType {
 
    mode?: any,
    serviceRequestId: any,
    onHide: () => void
    jobId?:any
    refrenceId?:any
}

export const ReferenceHistory = ({

    serviceRequestId,
    jobId,
    refrenceId

}: ReferenceHistoryPropsType) => {
    const [response , setResponse]  = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>();
    const [messageType, setMessageType] = useState<any>("info");
    const [showActionOfReference, setShowActionOfReference] = useState(false);
    const [ShowDynamicFormViewLoading, setShowDynamicFormViewLoading] = useState(false);
    const [dynamicForm, setDynamicForm] = useState<DynamicForm | any>("GeneralRequestForm");
    const [showDynamicForm, setShowDynamicForm] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(false);

async function ReferenceAndActionsasync(serviceRequestId) {
    setLoading(false)
    try {
        const res =  await getReferencesActions(serviceRequestId )
   
       setResponse(res.Data)
    } catch (error) {
        setResponse([])
        setMessageType("error")
    }
    setLoading(true)

}
    async function getDynamicFormAsync(id: string) {
    setShowDynamicFormViewLoading(false)
    try {
    const res = await getDynamicForm(id);
    if (res.Data){
     
        let data :any= []
        res.Data.map((item, index)=>{
            if(item.Name != "SignatureForm"){
                if(res.Data?.[index+1] &&  res.Data?.[index+1]?.Name =="SignatureForm" ){
                    data.push({...item , 
                        forms :[res.Data[index+1]]
                    })
                }else{
                    data.push(item)
                }
            }

        })
        setDynamicForm(data);
    }
    else
        setDynamicForm(undefined);
    if (dynamicForm) {
        setShowDynamicForm(true);
    }
    else { setShowDynamicForm(false) }            
    } catch (error) {
        setMessageType("error")
    }
    setShowDynamicFormViewLoading(true)
    }

    useEffect(() => {       
        if(showDynamicForm){
            getDynamicFormAsync(selectedRow.Id);
        }
    }, [ showDynamicForm ,selectedRow]);
    useEffect( () => {
        ReferenceAndActionsasync(serviceRequestId)
        
    }, [serviceRequestId]);
    



    return (
       

        <>
        <div  >
                  {
        loading ? (
               response ?
                 <TableTree
                   italic={"Reversed"}
                   params={"serviceRequestId"}
                   Data={[ response]}
                   DoubleClick={(e:any)=>{setSelectedRow(e ); console.log("setSelectedRow" ,e.Id ) ;setShowDynamicForm(true); ;setShowActionOfReference(true) }}
                   compressed={true}
                   theadData={ Object.keys(response)}
                   parentName={"ReferenceHistory"}
                   startIndex={4}
                   Childrenparams={"ReferenceList"}
                   defultShow={true}
                   /> 
                   : <Message message={"NoDataForPreview"} type={messageType} />       ) 

                : <Loading />
          }
        </div>        
          <JobActions jobId={jobId}  referenceId={refrenceId} />
            {showActionOfReference &&
                <ModalForm mode={"edit"} title={("Actions")} onHide={() => { setShowActionOfReference(false);setShowDynamicForm(false) }} show={showActionOfReference}>
                      {ShowDynamicFormViewLoading ? 
                          <>
                      {showDynamicForm &&
                          (dynamicForm ? (
                              <ModalStepper
                                  inDynamicForms={true}
                                  jobId={jobId}
                                  reload={setForceUpdate}
                                  onHide={() => { setShowDynamicForm(false); setForceUpdate(true);setShowDynamicForm(true); }}
                                  useGenerate={false}
                                  Id={selectedRow?.Id}
                                  refrenceId={selectedRow?.Id}
                                  taskTitle={selectedRow?.TaskTitle}
                                  formList={dynamicForm}
                                  parentMode={"view"}
                                  />
                          ) : (<Message message={"NoFormForPreview"} type={messageType} />))
                      }                
                          </>
                        :<Loading/>      
                      }
                    <ActionsOfReference referenceId={selectedRow?.Id} />
                </ModalForm>
            }
        
        
        </>





    );
}